const researchByYear = {
	el: {
		filterSelect: document.querySelector('.js-filter-year'),
		articles: document.querySelectorAll('.js-filtered-year')
	},

	fxFilter(element) {
		for (const article of this.el.articles) 
			article.style.display = element.value === article.dataset.id ? 'block' : 'none'
	},

	events() {
		this.el.filterSelect.addEventListener('change', e => this.fxFilter(e.currentTarget))
	},

	init() {
		this.el.filterSelect && this.events()
	}
}
researchByYear.init()